const ENSuggestions = {
	"Aguardando análise": "Waiting for review",
	"Data do último comentário": "Last comment date",
	"Detalhes da sugestão": "Suggestion details",
	"Em análise": "Under review",
	"Erro ao adicionar sugestão": "Error adding suggestion",
	"Erro ao carregar marcadores": "Error loading bookmarks",
	"Erro ao carregar sugestões": "Error loading suggestions",
	"Erro ao carregar sugestão": "Error loading suggestion",
	"Erro ao avaliar sugestão": "Error evaluating suggestion",
	"Marcadores": "Bookmarks",
	"Minhas": "Mine",
	"Minhas sugestões": "Mine suggestions",
	"Nova sugestão": "New suggestion",
	"Postada em": "Posted in",
	"Sugestão adicionada com sucesso": "Suggestion successfully added",
	"Sugestão avaliada com sucesso": "Suggestion evaluated successfully",
	"Todas sugestões": "All suggestions"
};

export default ENSuggestions;
